import { useComponentConfig } from 'js/hooks/component';
import { useCallback } from 'react';

import { PRODUCTS } from '../constants';

export const useGetEnabledProducts = () => {
    const { productCasino, productSportsbook } = useComponentConfig();

    return useCallback(() => {
        const products = [];

        if (productCasino) {
            products.push(PRODUCTS.CASINO);
        }

        if (productSportsbook) {
            products.push(PRODUCTS.SPORTSBOOK);
        }

        return products;
    }, [
        productCasino,
        productSportsbook
    ]);
};
